<fieldset>
  <div class="row d-flex align-items-center">
    <div class="col-sm-6">

    </div>

    <div class="col-sm-6 text-end" *ngIf="!isReadonly">
      <button (click)="expandNewEntry = !expandNewEntry"
              [ngClass]="!expandNewEntry ? '' : 'disabled'"
              type="button"
              aria-label="Nova entrada"
              class="btn btn-link disable-on-fieldset">
        <span class="icon-add"></span> <span>{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</span>
      </button>
    </div>
  </div>
  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</h3>
    <prestage-documentation-table-edit [isWorkflowMandatory]="true" [itemList]="documentsList" (listChanged)="onDocumentationChanged($event)"
                                       [isMandatoryDocumentation]="isMandatoryDocumentation" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber" [isIncapacity]="isWorkflowIncapacity" [workflowInstanceId]="workflowInstanceId"
                                       [dropdowns]="dropdowns" ></prestage-documentation-table-edit>
  </div>
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th scope="col">{{'CardDocumentation.DocumentsTable.Designation' | translate}} <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.Documents.Designation' | translate}}"></span></th>
        <th scope="col">{{'CardDocumentation.DocumentsTable.Name' | translate}}</th>
        <th scope="col">Ficheiro</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of documentsList; let i = index">
        <!--É readonly-->
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td style="color:red;font-size:2rem;padding-top:6px;text-align:center;">{{markAsMandatory(tableItem)? '*' : ''}}</td>
          <td>{{GetItemDescription(tableItem.designationTypeCode)}}</td>

          <td>{{tableItem.name }}</td>
          <td>{{tableItem.fileName}}</td>
          <td class="buttons-edit" *ngIf="!isReadonly" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" *ngIf="!readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : (tableItem.fileID!='0'  ) ? 'text-primary icon-edit' : 'text-primary icon-more' "></span>
              <span class="p-1" *ngIf="readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : (tableItem.fileID!='0') ? 'text-primary icon-more' : 'text-primary icon-more' "></span>
            </button>
          </td>
          <td class="buttons-edit" *ngIf="isReadonly">
            <button type="button" class="btn-icon" aria-label="Editar" aria-controls="collapseBasic" (click)="downloadDocument(tableItem,$event)">
              <span class="icon-download"></span>
            </button>
          </td>
        </tr>
        <!--Não é readonly e está expandido-->
        <tr *ngIf="!isReadonly && (expandedRowIndex == i)" [collapse]="expandedRowIndex != i" [isAnimated]="false" >
          <td class="p-0" colspan="5" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">


              <prestage-documentation-table-edit [isWorkflowMandatory]="true" [editIndex]="i" [itemList]="documentsList" (listChanged)="onDocumentationChanged($event)"
                                                 [isMandatoryDocumentation]="isMandatoryDocumentation" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber" [isIncapacity]="isWorkflowIncapacity" [workflowInstanceId]="workflowInstanceId"
                                                 [dropdowns]="dropdowns"></prestage-documentation-table-edit>

            </div>
          </td>
        </tr>
        <!--É readonly e está expandido-->
        <tr *ngIf="isReadonly && expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false" (click)="expandRow(i)">
          <td class="p-0" colspan="5">
            <div class="ml-5 mr-5 p-4">
              <label for="Observations">{{'CardDocumentation.DocumentsTable.Observations' | translate}}</label>
              <textarea class="form-control" [(ngModel)]="tableItem.observation" disabled rows="2" cols="100"> </textarea>


            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</fieldset>
